import * as React from 'react';
import {
  Box, Button, ButtonBase, InputLabel,
} from '@mui/material';
import { Asset, Member, Tenant } from '@ivymobi/orbit-core';
import { get } from 'lodash';
import { useFormContext } from 'react-hook-form';

import {
  Vcard,
  Form, TextInput, SaveButton,
  required, isEmail,
  Show, STextField,
} from '../components';
import { useTranslation } from 'react-i18next';

interface LogoInputProps {
  doUploadAsset: (file: File) => Promise<Asset[]>;
}
function LogoInput(props: LogoInputProps) {
  const { control, register, watch, setValue } = useFormContext();
  const { doUploadAsset } = props;

  register({ name: 'profile.avatar' });
  const defaultCover = get(control.defaultValuesRef.current, 'profile.avatar');
  const cover = watch('profile.avatar', defaultCover);

  const handleUploadAsset = (e) => {
    doUploadAsset(e.target.files[0])
    .then(([asset]) => {
      setValue('profile.avatar', asset.url, { shouldDirty: true });
    });
  };
  const id = 'vard-avatar-input';

  const handleReset = () => {
    document.getElementById(id).value=null

    setValue('profile.avatar', null, { shouldDirty: true });
  };

  var [t] = useTranslation();
  return (
    <div>
      <input id={id} type="file" accept="image/*"
        style={{ display: 'none' }}
        onChange={handleUploadAsset}
      />
      <Box display="flex" alignItems="flex-end" maxWidth={20}>
        <label htmlFor={id} >
          <InputLabel>{t('common.avatar')}</InputLabel>
          <div style={{ position: 'relative', marginTop: '12px' }}>
            <ButtonBase component="span"
              style={{
                height: '96px', width: '96px',
                borderRadius: 8,
                backgroundColor: '#f0f2f5',
                ... (cover ? {
                  backgroundImage: `url(${cover})`,
                  backgroundSize: 'contain',
                  backgroundPosition: 'center',
                  backgroundRepeat: 'no-repeat'
                } : {})
              }}
            />
            <div style={{
              color: 'white',
              backgroundColor: '#78797b',
              height: '24px', width: '96px',
              position: 'absolute', bottom: 0,
              borderBottomLeftRadius: 8,
              borderBottomRightRadius: 8,
              textAlign: 'center'
            }}>
              {t('YBT-ADMIN.YBT-ADMIN-020102.YBT-ADMIN-02010203')}
            </div>
          </div>
        </label>
        <Button size="small" style={{ marginLeft: '16px' }} color="primary"
          onClick={handleReset}
        >
          {t('YBT-ADMIN.YBT-ADMIN-020102.YBT-ADMIN-02010204')}
        </Button>
      </Box>
    </div>
  );
}

export interface VcardEditProps extends LogoInputProps {
  member: Member;
  tenant: Tenant;
  onSubmit: (data) => void
}
export default function VcardEdit (props: VcardEditProps) {
  const {
    member,
    member: {
      phone,
      profile: {
        name, avatar, email, title, department
      }
    },
    tenant: {
      name: tenantName,
      status,
      tntstatus: tntstatus,
      info: {
        logo,
        address
      },
    },
    doUploadAsset,
    onSubmit
  } = props;
  var [t] = useTranslation();
  return (
    <>
      <Vcard
        avatar={avatar}
        tenantName={tenantName}
        email={email}
        title={title}
        phone={phone}
        logo={logo}
        name={name}
        status={tntstatus}
        department={department}
        address={address}
      />
      <Box p={2} />
      <Form onSubmit={onSubmit} defaultValues={member} px={0}
        toolbar={ <SaveButton label={t('YBT-ADMIN.YBT-ADMIN-020102.YBT-ADMIN-02010210')} fullWidth variant="outlined" /> }
      >
        <Show value={member} title={t('YBT-ADMIN.YBT-ADMIN-040402.YBT-ADMIN-04040212')}>
          <LogoInput doUploadAsset={doUploadAsset} />
          <Box p={2} />
          <STextField field="phone" label={t('YBT-ADMIN.YBT-ADMIN-030101.YBT-ADMIN-03010107')} />
        </Show>
        <TextInput name="profile.name" label={t('YBT-ADMIN.YBT-ADMIN-030101.YBT-ADMIN-03010106')} fullWidth
          validate={[required()]}
        />
        <TextInput name="profile.email" label={t('YBT-ADMIN.YBT-ADMIN-040402.YBT-ADMIN-04040205')} fullWidth
          validate={[required(), isEmail()]}
        />
        <TextInput name="profile.department" label={t('YBT-ADMIN.YBT-ADMIN-040402.YBT-ADMIN-04040206')} fullWidth />
        <TextInput name="profile.title" label={t('YBT-ADMIN.YBT-ADMIN-030101.YBT-ADMIN-03010108')} fullWidth />
      </Form>
    </>
  );
}